import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {useLocation, useNavigate} from 'react-router-dom';

import Icon from 'presentation/icons';
import NotFoundImg from 'presentation/assets/images/general-lost.svg';
import {translations} from 'presentation/translations-new';
import {HomeEnum, SelectionFlowEnum} from 'presentation/constants';
import {useMediaQueries} from 'presentation/pages';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useSetRecoilState} from 'recoil';
import {accountDataStateRefresher} from 'presentation/pages/states';
import {StyledBox, StyledCard, StyledStack} from './styles';
import {ProductLogo} from '../ProductLogo';

const {backToHome} = translations['pt-br'].commons;
const {description, title} = translations['pt-br'].others.notFoundPage;

export function NotFoundPage() {
	const navigate = useNavigate();
	const {pathname} = useLocation();
	const {isMobile, isTablet} = useMediaQueries();
	const resetAccountData = useAccountDataStore(state => state.resetAccountData);
	const setAccountDataStateRefresher = useSetRecoilState(accountDataStateRefresher);

	const isPlanSelection = pathname.includes(SelectionFlowEnum.PLAN_SELECTION);

	const goBack = () => {
		if (isPlanSelection) {
			resetAccountData();
			setAccountDataStateRefresher(val => val + 1);
			window.location.href = '/';
			return;
		}

		navigate(HomeEnum.HOME_PAGE);
	};

	return (
		<StyledStack>
			<StyledBox>
				<img src={NotFoundImg} alt={title} />
			</StyledBox>
			<StyledCard elevation={0}>
				<ProductLogo />
				<Stack gap={isMobile ? 1 : 2}>
					<Typography textAlign={isTablet ? 'center' : 'start'} variant="h5">
						{title}
					</Typography>
					<Typography
						variant={isMobile ? 'body2' : 'body1'}
						textAlign={isTablet ? 'center' : 'start'}
						color="text.secondary">
						{description}
					</Typography>
				</Stack>
				<Button onClick={goBack} startIcon={<Icon name="arrow-left-filled" />}>
					{backToHome}
				</Button>
			</StyledCard>
		</StyledStack>
	);
}
